import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subject, firstValueFrom, takeUntil } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { ToastService } from '../../../core/services/toast/toast.service';
import { AlertService } from '../../../core/services/alert/alert.service';
import { cloneDeep } from 'lodash-es';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-modal-forgot-password',
    imports: [
        MatIconModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './modal-forgot-password.component.html',
    styleUrl: './modal-forgot-password.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ModalForgotPasswordComponent {
  restoreForm: FormGroup = new FormGroup({});
  showCloseAlert = false;
  isSendingEmail = false;

  private unsubscribe$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalForgotPasswordComponent>,
    private auth: AuthService,
    private toast: ToastService,
    private alert: AlertService,
    private sanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry
  ) {
    this.iconRegistry.addSvgIcon(
     'custom-unlock',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icon/custom-unlock.svg')
    );
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  initForm(): void {
    const receivedData = this.data ? cloneDeep(this.data) : null;
    const receivedEmail = receivedData?.email;

    this.restoreForm = new FormGroup({
      email: new FormControl(receivedEmail || null, [Validators.required, Validators.email])
    });

  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  async sendRestorePasswordEmail(): Promise<void> {
    try {
      this.isSendingEmail = true;
      const body: any = {
        email: this.restoreForm.value.email.trim().toLowerCase()
      };

      if (this.data?.redirectUrl) {
        body.redirectUrl = this.data.redirectUrl;
      }

      const response = await firstValueFrom(this.auth.sendRestorePasswordEmail(body));
      this.isSendingEmail = false;
      this.toast.presentSuccessToast(response.message, 10000);
      this.closeModal();
    } catch (errorResponse: any) {
      this.isSendingEmail = false;
      const errorMessage = errorResponse?.error?.message;
      this.toast.presentErrorToast(errorMessage || 'Hubo un error enviando correo de restauración');
    }
  }
}
